import { toast } from 'react-toastify'
import { splitApiErrorMessage } from './splitApiErrorMessage'

const TOAST_ID = 'manual-suscription-api-error'

/**
 * Renders a toast (not a blocking modal) with a bold title and an optional
 * subtitle beneath it, matching how phi-fondosmutuos-web-inversionista
 * presents suscription/create errors: a wide, pale-red banner near the top
 * with a warning icon, no auto-dismiss progress bar, and a close button.
 */
export const notifyApiError = (message?: string) => {
  const { title, subtitle } = splitApiErrorMessage(message)

  toast.error(
    <div>
      <div className='fw-bolder'>{title}</div>
      {subtitle && <div className='fs-7 mt-1'>{subtitle}</div>}
    </div>,
    {
      toastId: TOAST_ID,
      position: 'top-center',
      hideProgressBar: true,
      icon: <i className='bi bi-exclamation-triangle-fill fs-2 text-danger'></i>,
      style: {
        background: '#FFF5F5',
        border: '1px solid #f1aeb5',
        color: '#7a2530',
        maxWidth: 640,
        width: '90vw',
        boxShadow: 'none',
      },
    }
  )
}
